import { render, staticRenderFns } from "./GroupedBisnessQuestionView.vue?vue&type=template&id=ca69d6e4&scoped=true&"
import script from "./GroupedBisnessQuestionView.vue?vue&type=script&lang=ts&"
export * from "./GroupedBisnessQuestionView.vue?vue&type=script&lang=ts&"
import style0 from "./GroupedBisnessQuestionView.vue?vue&type=style&index=0&id=ca69d6e4&scoped=true&lang=css&"
import style1 from "./GroupedBisnessQuestionView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca69d6e4",
  null
  
)

export default component.exports